import React from 'react';
import { TTextBrickProps } from './TextBrick.types';
import classnames from 'classnames';
import s from './TextBrick.module.scss';

export const TextBrick: React.FC<TTextBrickProps> = ({ children, className }) => {
  return (
    <div className={classnames(s.box, className)}>
      <span>{children}</span>
    </div>
  );
};
